import React from "react";
import { useDragGhost } from "../hooks/index.js";
import { useEditorPreferences } from "@cadenza/preferences";

/**
 * A draggable shape component with icon and translated label
 * @param {Object} props
 * @param {Object} props.shape - The shape definition object
 * @returns {JSX.Element}
 */
const DraggableShape = ({ shape }) => {
  const { handleMouseDown, handleTouchStart } = useDragGhost();
  const { showIconLabels } = useEditorPreferences();
  const IconComponent = shape.icon;

  return (
    <div
      className={`rad-shape-item ${shape.class}`}
      onMouseDown={handleMouseDown(shape)}
      onTouchStart={handleTouchStart(shape)}
      title={shape.label}
    >
      {showIconLabels && <span className="rad-shape-label">{shape.label}</span>}
      <IconComponent
        width={shape.width}
        height={shape.height}
        className="rad-shape-icon"
      />
    </div>
  );
};

export default React.memo(DraggableShape);
